

// const isDev = process.env.REACT_APP_ENV === 'dev';
const accessLevel = process.env.REACT_APP_ACCESS_LEVEL_LOG;

// 

const getCallerComponent = () => {
  const err = new Error()



  const stackLines = err.stack?.split('\n') || []
  const callerLine = stackLines[3] || '' //👉 línea 3 generalmente es la que llama

  //👉 Intenta extraer el nombre de la función o componente
  const match = callerLine.match(/at (\w+)/)
  return match ? match[1] : 'unknown'
};

const logger = {
  info: (...args) => {
    if (accessLevel >= 1) {
      const caller = getCallerComponent()
      console.info(`%c[INFO][${caller}]`, 'color: rgba(107, 164, 102);', ...args)
    }
  },
  warn: (...args) => {
    if (accessLevel >= 3) {
      const caller = getCallerComponent();
      console.warn(`%c[WARN][${caller}]`, 'color: orange;', ...args)
    }
  },
  error: (...args) => {
    if (accessLevel >= 4) {
      const caller = getCallerComponent();
      console.error(`%c[ERROR][${caller}]`, 'color: red;', ...args)
    }

  },
  debug: (...args) => {
    if (accessLevel >= 2) {
      const caller = getCallerComponent();
      console.debug(`%c[DEBUG][${caller}]`, 'color: gray;', ...args)
    }
  }
};

export default logger

